import { connect } from 'react-redux';
import { compose } from 'redux';
import { withFirebase, withFirestore, isLoaded, isEmpty } from 'react-redux-firebase'
import { withContext, getContext, withHandlers,lifecycle } from 'recompose'
import PropTypes from 'prop-types'


import Admin from '../components/Admin'

import updateCpIds from '../services/update-cp-ids'
import { 
  checkPermissions, selectActivityId,populateCpsIfNeeded,invalidateActivityId} from '../actions'


const withStore = compose(
  withContext({ store: PropTypes.object }, () => {}),
  getContext({ store: PropTypes.object }),
)
const handlers = {
    loadData: ({store}) => err => store.firestore.get({ collection: 'activities'}),
    loadAssessments: ({store}) => err => store.firestore.get({ collection: 'assessments'}),

    loadCps: ({store}) => err => store.firestore.get({ collection: 'competencies', where:['company.id','==','JFC']}),

    // company id doesn't work yet
    loadAssessmentsByRater: ({store}) => (companyId) => err =>
      store.firestore.get({ collection: 'assessmentsByRater', where:['company.id','==','JFC']}),
    loadEmployees: ({store}) => err => store.firestore.get({ collection: 'employees', where:['company.id','==','JFC']}),
    loadUsers: ({store}) => err => store.firestore.get({ collection: 'users'}),

    correctCp: ({store}) => err => store.firestore.get({collection: 'competencies', doc: '00jHPfWFI0NDll646IUZ'})
      .then(doc => { 
        const data = doc.data()  
        data.levels[3].indicators = [
          {id: "oJVCMSG0V9VQeHO5pvJO", score: "1", text: 'Recognizes internal factors that may affect the direction of the team and uses this awareness to come up with solutions to key business problems.'},
          {id: "z07JXtM8vUzsxppit5Np", score: "2", text: 'Integrates and balances big picture concern with the day to day activities'},        
          {id: "YXJVBVlFMrJ6DJvP2WUq", score: "3", text: 'Strikes a general balance between addressing long term issues and day to day activities'}]
          //store.firestore.update('competencies/00jHPfWFI0NDll646IUZ',data).then(data => console.log(data)).catch(err => console.error(err))
          return doc
      })
      ,
    addJSONCps: ({store}) => (cpsJson) => e => {
      cpsJson.map(cp => ({ id: 
        store.firestore.add('competencies',cp)
        , name: cp.name }) )
        .map(cp => console.log(cp))
        
    },
    addCp: ({store}) => (cp) =>  err => store.firestore.add('competencies',cp),
    updateCpIds: ({store}) => (id) => err => updateCpIds(id,store),


    cleanCps: ({store}) => err => {
      store.firestore.get({ collection: 'competencies', where:['name','==','Formulating strategies and concepts']})
        .then(snapshot => snapshot.docs)
        .then(docs => docs.map(doc => {
          if (doc.id !== '00jHPfWFI0NDll646IUZ' )
            doc.ref.delete().then(console.log('deleted' + doc.id))
          return doc
        }))
    
    },


    addData: ({store}) => (cp) => err => store.firestore.add('competencies',cp),
    updateData: ({store}) => (cp) => err => store.firestore.update('competencies/DHvmqf15hUeFplS8sVww',cp),
    updateSubcollection: ({store}) => (cp) => err => store.firestore.update(
      { collection: 'activities', doc: 'DHvmqf15hUeFplS8sVww', subcollections: [ {collection:'competencies'} ]},cp),
    
    /** Admin copy of competencies from assessments/<doc id>/activities */
    loadAssessmentsSubcollections: ({store}) => (id)=> e => store.firestore.get({ collection: 'assessments', doc: id, subcollections: [ {collection:'activities'} ]}),    
    
    createCps: ({store}) => (assessment,id)  => e => {
      const activities = assessment[id].activities
      
      //const cps = 
      Object.keys(activities).map(key => {
          return activities[key].competencies 
            ? activities[key].competencies.map(cp => 
              //store.firestore.add('competencies',cp)
              console.log(cp.name)
            )
            : false
      })
      //Promise.all(cps.reduce((prev,curr) => prev.concat(curr),[])).then(values => console.log(values));
      
    },
    /**
     * qsMEebbJG3Q9Q2AAywns
     * 
     *             
     */
    createAssessments: ({store}) => (parameter) => ev => {

      [ { company: 'TST',
          rater: 'orvin.hilomen@strata.ph',
          eeFirstName: 'Paolo', 
          eeLastName: 'Mirasol',
          act1: 'Coach'
        }      
      ].map( assignment => {


      const promises = []
/*
      promises.push(store.firestore.get({ collection: 'users', where: ['email','==','aai5@strata.ph'] }))
      promises.push(store.firestore.get({ collection: 'employees', where: ['firstName','==','One'] }))
      promises.push(store.firestore.get({ collection: 'activities', where: ['name','==','Coaching Role Play'] }))
      promises.push(store.firestore.get({ collection: 'activities', where: ['name','==','Analysis Presentation'] }))
      promises.push(store.firestore.get({ collection: 'activities', where: ['name','==','Group Exercise'] }))
*/
      promises.push(store.firestore.get({ collection: 'users', where: ['email','==',assignment.rater] }))
      promises.push(store.firestore.get({ collection: 'employees',
        where: [ ['company.id','==',assignment.company],
          ['firstName','==',assignment.eeFirstName],['lastName','==',assignment.eeLastName] ]  }))
      promises.push(store.firestore.get({ collection: 'activities',
        where: [ ['name','==',assignment.act1],['company.id','==',assignment.company] ] }))
      //promises.push(store.firestore.get({ collection: 'activities', where: ['name','==',assignment.act2] }))

      Promise.all(promises).then( ([raterSnapshot,employeeSnapshot,act1Snapshot,act2Snapshot] ) => {
        const rater = raterSnapshot.docs[0].ref
        const employee = employeeSnapshot.docs[0].ref
        const act1 = act1Snapshot.docs[0].ref
        //const act2 = act2Snapshot.docs[0].ref

        
        store.firestore.add('assessmentsByRater',{ company: { id: 'TST' }, answers: [],
            activities: [
              act1,
              //act2
            ],rater,employee })
          .then(docRef => { console.log(docRef.id); console.log(assignment) })
        

      } )
      
      } )


    }
    
}
//assessment[id].activities.map(activity => console.log(activity.id))

function mapStateToProps(state) {
  
  const { permissions,  firestore,
  selectedActivityId,cpsByActivityId,  firebase: { auth, profile } } = state
  const { 
    //isFetching, lastUpdated, 
    items: cps} = cpsByActivityId[selectedActivityId]
    || {isFetching: true,items: []}


    return { permissions, 
          selectedActivityId, cps,
          activities: firestore.ordered.activities, // state.firebase
          assessmentActivities: firestore.data.assessments,
          competencies: firestore.data.competencies,

          temp: firestore.data.temp,

          backup: { activities: firestore.data.activities,
                    assessmentsByRater: firestore.data.assessmentsByRater,
                    competencies: firestore.data.competencies,
                    employees: firestore.data.employees,
                    users: firestore.data.users 
                  },

          auth, profile
      }
      
     
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
      
        checkPermissions: (e) => { e.preventDefault(); dispatch(checkPermissions())  },

        selectActivityId: (activityId) =>  { dispatch(selectActivityId(activityId))},
        populateCpsIfNeeded: (activityId) => { dispatch(populateCpsIfNeeded(activityId,ownProps.store)) },
        invalidateActivityId: (activityId) =>{ dispatch(invalidateActivityId(activityId))},


    }
}



export default compose(
  //withFirestore,
  withStore,


  withHandlers(handlers),
  lifecycle({
    componentWillMount() {
      const {loadData,loadCps,loadAssessmentsByRater,loadEmployees,loadUsers,correctCp,
        store, store : { getState } } = this.props
      
      loadData()

      // Backup
      loadAssessmentsByRater('JFC')
      loadEmployees()
      loadUsers()

      //correctCp()
      
      //this.props.loadAssessments()

      /*
      console.log('cps loading')
      console.log(isLoaded(getState().firestore.data.competencies))
      */
      loadCps().then(snapshot => {

        /*
        console.log('cps done')
        console.log(store.firestore)
        console.log(isLoaded(getState().firestore.data.competencies))
        console.log(getState().firestore.data.competencies)
        */
        return snapshot
      })

      
    }
  }),
  withFirebase,
  //firestoreConnect(['activities']),

  connect(
    mapStateToProps,
    mapDispatchToProps
))(Admin)





// WEBPACK FOOTER //
// ./src/admin/containers/Admin.js